
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.606 3.281c1.656-1.655 4.408-1.655 6.065 0 1.489 1.489 1.71 3.862.485 5.574l-.033.047a.954.954 0 01-1.552-1.107l.033-.048a2.4 2.4 0 00-3.652-3.093L2.61 7.997c-.938.911-.938 2.457 0 3.394.829.83 2.14.938 3.092.256l.048-.06a.98.98 0 011.328.248.953.953 0 01-.22 1.33l-.048.034c-1.74 1.223-4.06 1.027-5.549-.459a4.304 4.304 0 010-6.088l3.345-3.37zm8.787 7.41a4.307 4.307 0 01-6.55-5.546l.033-.047c.28-.426.875-.527 1.328-.22.43.28.53.875.224 1.327l-.033.048c-.682.929-.575 2.262.256 3.093a2.406 2.406 0 003.396 0l3.341-3.343c.939-.938.939-2.483 0-3.394a2.4 2.4 0 00-3.091-.256l-.048.032c-.429.307-1.024.182-1.328-.22a.951.951 0 01.22-1.33l.048-.033a4.308 4.308 0 015.549.46 4.3 4.3 0 010 6.086l-3.345 3.344z","fill":"#282E3E"}})])
          )
        }
      }
    